export const AUTH_USER_SET = "AUTH_USER_SET";
export const AUTH_LOADING = "AUTH_LOADING";



// WEBPACK FOOTER //
// ./src/actions/auth/constants.js